import React from "react";
import "./bubles.css";

function Background({ scale, color, rotate, izq, der, arriba, abajo }) {
  return (
    <div
      className="background"
      style={{
        marginTop: `${arriba}rem`,
        marginBottom: `${abajo}rem`,
        marginLeft: `${izq}rem`,
        marginRight: `${der}rem`,
      }}
    >
      <section
        style={{ transform: `rotate(${rotate}deg)`, transformOrigin: "center" }}
      >
        <div className="blob" style={{ transform: `scale(${scale})` }}>
          <div className="svg-container">
            <div id="svg">
              <svg
                viewBox="0 0 500 500"
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                id="blobSvg"
              >
                <defs>
                  <filter
                    id="shadow"
                    x="-60%"
                    y="-70%"
                    width="170%"
                    height="240%"
                  >
                    <feDropShadow dx="2" dy="2" stdDeviation="6" />
                  </filter>
                </defs>
                <path
                  fill="transparent"
                  stroke-width="35px"
                  stroke="#fff400"
                  transform="translate(20, 20)"
                  filter="url(#shadow)"
                >
                  <animate
                    attributeName="d"
                    dur="9000ms"
                    repeatCount="indefinite"
                    values="M435.21447,330.18679Q441.44277,410.37359,366.25598,447.90818Q291.06918,485.44277,208.86163,474.51887Q126.65409,463.59497,105.66604,386.67296Q84.67799,309.75094,67.51195,243.43774Q50.34591,177.12453,95.77673,119.74214Q141.20755,62.35975,216.62453,38.08302Q292.04151,13.80629,359.02767,57.89623Q426.01384,101.98616,427.5,175.99308Q428.98616,250,435.21447,330.18679Z;
                    M442.5,326.5Q432,403,357.5,419.5Q283,436,214,434Q145,432,92,379.5Q39,327,32,247.5Q25,168,85,117.5Q145,67,215.5,57.5Q286,48,338,90Q390,132,421.5,191Q453,250,442.5,326.5Z;
                    M413,308Q388,366,337.5,413Q287,460,223,434Q159,408,113.5,362Q68,316,54,245Q40,174,100.5,134.5Q161,95,225,61.5Q289,28,355.5,67Q422,106,430,178Q438,250,413,308Z;
                    M435.21447,330.18679Q441.44277,410.37359,366.25598,447.90818Q291.06918,485.44277,208.86163,474.51887Q126.65409,463.59497,105.66604,386.67296Q84.67799,309.75094,67.51195,243.43774Q50.34591,177.12453,95.77673,119.74214Q141.20755,62.35975,216.62453,38.08302Q292.04151,13.80629,359.02767,57.89623Q426.01384,101.98616,427.5,175.99308Q428.98616,250,435.21447,330.18679Z"
                  />
                </path>
                <g transform="translate(125, 125), scale(0.5)">
                  <path
                    fill="transparent"
                    stroke-width="60px"
                    stroke="#fff400"
                    filter="url(#shadow)"
                  >
                    <animate
                      attributeName="d"
                      dur="9000ms"
                      repeatCount="indefinite"
                      values="M435.21447,330.18679Q441.44277,410.37359,366.25598,447.90818Q291.06918,485.44277,208.86163,474.51887Q126.65409,463.59497,105.66604,386.67296Q84.67799,309.75094,67.51195,243.43774Q50.34591,177.12453,95.77673,119.74214Q141.20755,62.35975,216.62453,38.08302Q292.04151,13.80629,359.02767,57.89623Q426.01384,101.98616,427.5,175.99308Q428.98616,250,435.21447,330.18679Z;
                    M442.5,326.5Q432,403,357.5,419.5Q283,436,214,434Q145,432,92,379.5Q39,327,32,247.5Q25,168,85,117.5Q145,67,215.5,57.5Q286,48,338,90Q390,132,421.5,191Q453,250,442.5,326.5Z;
                    M413,308Q388,366,337.5,413Q287,460,223,434Q159,408,113.5,362Q68,316,54,245Q40,174,100.5,134.5Q161,95,225,61.5Q289,28,355.5,67Q422,106,430,178Q438,250,413,308Z;
                    M435.21447,330.18679Q441.44277,410.37359,366.25598,447.90818Q291.06918,485.44277,208.86163,474.51887Q126.65409,463.59497,105.66604,386.67296Q84.67799,309.75094,67.51195,243.43774Q50.34591,177.12453,95.77673,119.74214Q141.20755,62.35975,216.62453,38.08302Q292.04151,13.80629,359.02767,57.89623Q426.01384,101.98616,427.5,175.99308Q428.98616,250,435.21447,330.18679Z"
                    />
                  </path>
                </g>
                <g transform="translate(215, 215), scale(0.15)">
                  <path
                    fill="#fff400"
                    stroke-width="90px"
                    stroke="#fff400"
                    filter="url(#shadow)"
                  >
                    <animate
                      attributeName="d"
                      dur="9000ms"
                      repeatCount="indefinite"
                      values="M435.21447,330.18679Q441.44277,410.37359,366.25598,447.90818Q291.06918,485.44277,208.86163,474.51887Q126.65409,463.59497,105.66604,386.67296Q84.67799,309.75094,67.51195,243.43774Q50.34591,177.12453,95.77673,119.74214Q141.20755,62.35975,216.62453,38.08302Q292.04151,13.80629,359.02767,57.89623Q426.01384,101.98616,427.5,175.99308Q428.98616,250,435.21447,330.18679Z;
                    M442.5,326.5Q432,403,357.5,419.5Q283,436,214,434Q145,432,92,379.5Q39,327,32,247.5Q25,168,85,117.5Q145,67,215.5,57.5Q286,48,338,90Q390,132,421.5,191Q453,250,442.5,326.5Z;
                    M413,308Q388,366,337.5,413Q287,460,223,434Q159,408,113.5,362Q68,316,54,245Q40,174,100.5,134.5Q161,95,225,61.5Q289,28,355.5,67Q422,106,430,178Q438,250,413,308Z;
                    M435.21447,330.18679Q441.44277,410.37359,366.25598,447.90818Q291.06918,485.44277,208.86163,474.51887Q126.65409,463.59497,105.66604,386.67296Q84.67799,309.75094,67.51195,243.43774Q50.34591,177.12453,95.77673,119.74214Q141.20755,62.35975,216.62453,38.08302Q292.04151,13.80629,359.02767,57.89623Q426.01384,101.98616,427.5,175.99308Q428.98616,250,435.21447,330.18679Z"
                    />
                  </path>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Background;
